import { render, staticRenderFns } from "./tabBar.vue?vue&type=template&id=387be18c&"
import script from "./tabBar.vue?vue&type=script&lang=js&"
export * from "./tabBar.vue?vue&type=script&lang=js&"
import style0 from "./tabBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports